import React, { FC } from 'react';
import className from 'classnames';
import { Asset, DownloadIcon } from '@clearcover/atlas';

import { Tooltip } from 'Shared/components';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

export const QuotePdfLink: FC = () => {
  const { rate, rateLoading } = useAppContext();

  if (!rate?.pdfDownloadURL) {
    return null;
  }

  if (rateLoading) {
    return (
      <Tooltip
        tooltip="Please wait while rate updates."
        testId="download-quote-disabled-rate-updating"
      >
        <DownloadQuote />
      </Tooltip>
    );
  }

  return (
    <a
      data-testid="download-quote-link"
      download
      href={rate.pdfDownloadURL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <DownloadQuote active />
    </a>
  );
};

interface DownloadQuoteProps {
  active?: boolean;
}

const DownloadQuote: FC<DownloadQuoteProps> = (props) => {
  return (
    <div
      className={className(styles.link, {
        [styles.disabled]: !props.active,
      })}
    >
      <Asset
        className={styles.icon}
        icon={DownloadIcon}
        height={14}
        width={14}
        description={
          props.active
            ? 'Click to download quote PDF'
            : 'Download quote PDF is disabled'
        }
      />
      Download Quote
    </div>
  );
};
